export const nameBankArray = {
    '014': 'ธนาคาร ไทยพาณิชย์',
    '002': 'ธนาคาร กรุงเทพ',
    '004': 'ธนาคาร กสิกรไทย',
    '006': 'ธนาคาร กรุงไทย',
    '034': 'ธนาคาร ธกส',
    '011': 'ธนาคาร ทีเอ็มบีธนชาต',
    '017': 'ธนาคาร ซิตี้แบงก์',
    '020': 'ธนาคาร สแตนดาร์ดชาร์เตอร์ด',
    '022': 'ธนาคาร ซีไอเอ็มบี',
    '024': 'ธนาคาร ยูโอบี',
    '025': 'ธนาคาร กรุงศรีฯ',
    '030': 'ธนาคาร ออมสิน',
    '033': 'ธนาคาร ธอส.',
    '073': 'ธนาคาร แลนด์แอนด์เฮ้าส',
    '067': 'ธนาคาร ทิสโก้',
    '069': 'ธนาคาร เกียรตินาคิน',
    '066': 'ธนาคาร อิสลาม',
    'co.th.promptpay.qr': 'พร้อมเพย์',
    'co.th.truemoney.wallet': 'ทรูมันนี่วอเล็ท',
}

export const bankArray = {
    'co.th.truemoney.wallet': {
        code: 'co.th.truemoney.wallet',
        color: '#ffffff',
        official_name: 'ทรูมันนี่วอเล็ท',
        nice_name: 'ทรูมันนี่วอเล็ท',
    },
    'NSGPAY': {
        code: 'co.th.promptpay.qr',
        color: '#ffffff',
        official_name: 'ทรูมันนี่วอเล็ท',
        nice_name: 'ทรูมันนี่วอเล็ท',
    },
    'HENGPAY': {
        code: 'co.th.promptpay.qr',
        color: '#ffffff',
        official_name: 'ทรูมันนี่วอเล็ท',
        nice_name: 'ทรูมันนี่วอเล็ท',
    },
    '002': {
        code: 'bbl',
        color: '#1e4598',
        official_name: 'BANGKOK BANK PUBLIC COMPANY LTD.',
        nice_name: 'Bangkok Bank',
    },
    '004': {
        code: 'kbank',
        color: '#138f2d',
        official_name: 'KASIKORNBANK PUBLIC COMPANY LTD.',
        nice_name: 'Kasikornbank',
    },
    '005': {
        code: 'rbs',
        color: '#032952',
        official_name: 'THE ROYAL BANK OF SCOTLAND PLC',
        nice_name: 'Royal Bank of Scotland',
    },
    '006': {
        code: 'ktb',
        color: '#1ba5e1',
        official_name: 'KRUNG THAI BANK PUBLIC COMPANY LTD.',
        nice_name: 'Krungthai Bank',
    },
    '008': {
        code: 'jpm',
        color: '#321c10',
        official_name: 'JPMORGAN CHASE BANK, NATIONAL ASSOCIATION',
        nice_name: 'J.P. Morgan',
    },
    '010': {
        code: 'mufg',
        color: '#d61323',
        official_name: 'THE BANK OF TOKYO-MITSUBISHI UFJ, LTD.',
        nice_name: 'Bank of Tokyo-Mitsubishi UFJ',
    },
    '011': {
        code: 'tmb',
        color: '#1279be',
        official_name: 'TMB BANK PUBLIC COMPANY LIMITED.',
        nice_name: 'TMB Bank',
    },
    '014': {
        code: 'scb',
        color: '#4e2e7f',
        official_name: 'SIAM COMMERCIAL BANK PUBLIC COMPANY LTD.',
        nice_name: 'Siam Commercial Bank',
    },
    '017': {
        code: 'citi',
        color: '#1583c7',
        official_name: 'CITIBANK, N.A.',
        nice_name: 'Citibank',
    },
    '018': {
        code: 'smbc',
        color: '#a0d235',
        official_name: 'SUMITOMO MITSUI BANKING CORPORATION',
        nice_name: 'Sumitomo Mitsui Banking Corporation',
    },
    '020': {
        code: 'sc',
        color: '#0f6ea1',
        official_name: 'STANDARD CHARTERED BANK (THAI) PUBLIC COMPANY LIMITED',
        nice_name: 'Standard Chartered (Thai)',
    },
    '022': {
        code: 'cimb',
        color: '#7e2f36',
        official_name: 'CIMB THAI BANK PUPBLIC COMPANY LTD.',
        nice_name: 'CIMB Thai Bank',
    },
    '024': {
        code: 'uob',
        color: '#0b3979',
        official_name: 'UNITED OVERSEAS BANK (THAI) PUBLIC COMPANY LIMITED',
        nice_name: 'United Overseas Bank (Thai)',
    },
    '025': {
        code: 'bay',
        color: '#fec43b',
        official_name: 'BANK OF AYUDHYA PUBLIC COMPANY LTD.',
        nice_name: 'Bank of Ayudhya (Krungsri)',
    },
    '026': {
        code: 'mega',
        color: '#815e3b',
        official_name: 'MEGA INTERNATIONAL COMMERCIAL BANK PUBLIC COMPANY LIMITED',
        nice_name: 'Mega International Commercial Bank',
    },
    '027': {
        code: 'boa',
        color: '#e11e3c',
        official_name: 'BANK OF AMERICA, NATIONAL ASSOCIATION',
        nice_name: 'Bank of America',
    },
    '028': {
        code: 'cacib',
        color: '#0e765b',
        official_name: 'CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK',
        nice_name: 'Crédit Agricole',
    },
    '030': {
        code: 'gsb',
        color: '#eb198d',
        official_name: 'THE GOVERNMENT SAVINGS BANK',
        nice_name: 'Government Savings Bank',
    },
    '031': {
        code: 'hsbc',
        color: '#fd0d1b',
        official_name: 'THE HONGKONG AND SHANGHAI BANKING CORPORATION LTD.',
        nice_name: 'Hongkong and Shanghai Banking Corporation',
    },
    '032': {
        code: 'db',
        color: '#0522a5',
        official_name: 'DEUTSCHE BANK AG.',
        nice_name: 'Deutsche Bank',
    },
    '033': {
        code: 'ghb',
        color: '#f57d23',
        official_name: 'THE GOVERNMENT HOUSING BANK',
        nice_name: 'Government Housing Bank',
    },
    '034': {
        code: 'baac',
        color: '#4b9b1d',
        official_name: 'BANK FOR AGRICULTURE AND AGRICULTURAL COOPERATIVES',
        nice_name: 'Bank for Agriculture and Agricultural Cooperatives',
    },
    '039': {
        code: 'mb',
        color: '#150b78',
        official_name: 'MIZUHO BANK, LTD.',
        nice_name: 'Mizuho Bank',
    },
    '045': {
        code: 'bnp',
        color: '#14925e',
        official_name: 'BNP PARIBAS',
        nice_name: 'BNP Paribas',
    },
    '066': {
        code: 'ibank',
        color: '#184615',
        official_name: 'ISLAMIC BANK OF THAILAND',
        nice_name: 'Islamic Bank of Thailand',
    },
    '067': {
        code: 'tisco',
        color: '#12549f',
        official_name: 'TISCO BANK PUBLIC COMPANY LIMITED',
        nice_name: 'Tisco Bank',
    },
    '069': {
        code: 'kk',
        color: '#199cc5',
        official_name: 'KIATNAKIN BANK PUBLIC COMPANY LIMITED',
        nice_name: 'Kiatnakin Bank',
    },
    '070': {
        code: 'icbc',
        color: '#c50f1c',
        official_name: 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED',
        nice_name: 'Industrial and Commercial Bank of China (Thai)',
    },
    '071': {
        code: 'tcrb',
        color: '#0a4ab3',
        official_name: 'THE THAI CREDIT RETAIL BANK PUBLIC COMPANY LIMITED',
        nice_name: 'Thai Credit Retail Bank',
    },
    '073': {
        code: 'lhb',
        color: '#6d6e71',
        official_name: 'LAND AND HOUSES BANK PUBLIC COMPANY LIMITED',
        nice_name: 'Land and Houses Bank',
    },
    bbl: {
        code: '002',
        color: '#1e4598',
        official_name: 'BANGKOK BANK PUBLIC COMPANY LTD.',
        nice_name: 'Bangkok Bank',
    },
    kbank: {
        code: '004',
        color: '#138f2d',
        official_name: 'KASIKORNBANK PUBLIC COMPANY LTD.',
        nice_name: 'Kasikornbank',
    },
    rbs: {
        code: '005',
        color: '#032952',
        official_name: 'THE ROYAL BANK OF SCOTLAND PLC',
        nice_name: 'Royal Bank of Scotland',
    },
    ktb: {
        code: '006',
        color: '#1ba5e1',
        official_name: 'KRUNG THAI BANK PUBLIC COMPANY LTD.',
        nice_name: 'Krungthai Bank',
    },
    jpm: {
        code: '008',
        color: '#321c10',
        official_name: 'JPMORGAN CHASE BANK, NATIONAL ASSOCIATION',
        nice_name: 'J.P. Morgan',
    },
    mufg: {
        code: '010',
        color: '#d61323',
        official_name: 'THE BANK OF TOKYO-MITSUBISHI UFJ, LTD.',
        nice_name: 'Bank of Tokyo-Mitsubishi UFJ',
    },
    tmb: {
        code: '011',
        color: '#1279be',
        official_name: 'TMB BANK PUBLIC COMPANY LIMITED.',
        nice_name: 'TMB Bank',
    },
    scb: {
        code: '014',
        color: '#4e2e7f',
        official_name: 'SIAM COMMERCIAL BANK PUBLIC COMPANY LTD.',
        nice_name: 'Siam Commercial Bank',
    },
    citi: {
        code: '017',
        color: '#1583c7',
        official_name: 'CITIBANK, N.A.',
        nice_name: 'Citibank',
    },
    smbc: {
        code: '018',
        color: '#a0d235',
        official_name: 'SUMITOMO MITSUI BANKING CORPORATION',
        nice_name: 'Sumitomo Mitsui Banking Corporation',
    },
    sc: {
        code: '020',
        color: '#0f6ea1',
        official_name: 'STANDARD CHARTERED BANK (THAI) PUBLIC COMPANY LIMITED',
        nice_name: 'Standard Chartered (Thai)',
    },
    cimb: {
        code: '022',
        color: '#7e2f36',
        official_name: 'CIMB THAI BANK PUPBLIC COMPANY LTD.',
        nice_name: 'CIMB Thai Bank',
    },
    uob: {
        code: '024',
        color: '#0b3979',
        official_name: 'UNITED OVERSEAS BANK (THAI) PUBLIC COMPANY LIMITED',
        nice_name: 'United Overseas Bank (Thai)',
    },
    bay: {
        code: '025',
        color: '#fec43b',
        official_name: 'BANK OF AYUDHYA PUBLIC COMPANY LTD.',
        nice_name: 'Bank of Ayudhya (Krungsri)',
    },
    mega: {
        code: '026',
        color: '#815e3b',
        official_name: 'MEGA INTERNATIONAL COMMERCIAL BANK PUBLIC COMPANY LIMITED',
        nice_name: 'Mega International Commercial Bank',
    },
    boa: {
        code: '027',
        color: '#e11e3c',
        official_name: 'BANK OF AMERICA, NATIONAL ASSOCIATION',
        nice_name: 'Bank of America',
    },
    cacib: {
        code: '028',
        color: '#0e765b',
        official_name: 'CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK',
        nice_name: 'Crédit Agricole',
    },
    gsb: {
        code: '030',
        color: '#eb198d',
        official_name: 'THE GOVERNMENT SAVINGS BANK',
        nice_name: 'Government Savings Bank',
    },
    hsbc: {
        code: '031',
        color: '#fd0d1b',
        official_name: 'THE HONGKONG AND SHANGHAI BANKING CORPORATION LTD.',
        nice_name: 'Hongkong and Shanghai Banking Corporation',
    },
    db: {
        code: '032',
        color: '#0522a5',
        official_name: 'DEUTSCHE BANK AG.',
        nice_name: 'Deutsche Bank',
    },
    ghb: {
        code: '033',
        color: '#f57d23',
        official_name: 'THE GOVERNMENT HOUSING BANK',
        nice_name: 'Government Housing Bank',
    },
    baac: {
        code: '034',
        color: '#4b9b1d',
        official_name: 'BANK FOR AGRICULTURE AND AGRICULTURAL COOPERATIVES',
        nice_name: 'Bank for Agriculture and Agricultural Cooperatives',
    },
    mb: {
        code: '039',
        color: '#150b78',
        official_name: 'MIZUHO BANK, LTD.',
        nice_name: 'Mizuho Bank',
    },
    bnp: {
        code: '045',
        color: '#14925e',
        official_name: 'BNP PARIBAS',
        nice_name: 'BNP Paribas',
    },
    ibank: {
        code: '066',
        color: '#184615',
        official_name: 'ISLAMIC BANK OF THAILAND',
        nice_name: 'Islamic Bank of Thailand',
    },
    tisco: {
        code: '067',
        color: '#12549f',
        official_name: 'TISCO BANK PUBLIC COMPANY LIMITED',
        nice_name: 'Tisco Bank',
    },
    kk: {
        code: '069',
        color: '#199cc5',
        official_name: 'KIATNAKIN BANK PUBLIC COMPANY LIMITED',
        nice_name: 'Kiatnakin Bank',
    },
    icbc: {
        code: '070',
        color: '#c50f1c',
        official_name: 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED',
        nice_name: 'Industrial and Commercial Bank of China (Thai)',
    },
    tcrb: {
        code: '071',
        color: '#0a4ab3',
        official_name: 'THE THAI CREDIT RETAIL BANK PUBLIC COMPANY LIMITED',
        nice_name: 'Thai Credit Retail Bank',
    },
    lhb: {
        code: '073',
        color: '#6d6e71',
        official_name: 'LAND AND HOUSES BANK PUBLIC COMPANY LIMITED',
        nice_name: 'Land and Houses Bank',
    },
}


// WEBPACK FOOTER //
// ./src/services/modules/Bank.services.js